import Service from "./BaseService";

const get = () =>
  Service.get('/odoo/request');

const RequestService = {
  get,
};

export default RequestService;